import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web
import authReducer from "../features/authSlice";
import modalsReducer from "../features/modalSlice";
import courierReducer from "../features/CourrierSlice";
import utilReducer from "../features/utilSlice";
import adminReducer from "../features/adminSlice";
import ordersReducer from "../features/orderSlice";
import settingsReducer from "../features/settingsSlice";
import analyticsReducer from "../features/analyticsSlice";
import kycReducer from "../features/kycSlice";
import couponReducer from "../features/CouponSlice";
import requestReducer from "../features/requestManagementSlice";
import notificationsReducer from "../features/notificationSlice";
import productsReducer from "../features/ProductSlice";
import { combineReducers } from "redux";

// Persist Configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "orders", "products"], // Persist only the auth state
};

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  modals: modalsReducer,
  courier: courierReducer,
  util: utilReducer,
  admin: adminReducer,
  orders: ordersReducer,
  settings: settingsReducer,
  analytics: analyticsReducer,
  kyc: kycReducer,
  coupons: couponReducer,
  requests: requestReducer,
  notifications: notificationsReducer,
  products: productsReducer,
});

// Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Required for redux-persist
    }),
});

// Persistor
export const persistor = persistStore(store);

// Types
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
